import { IDocumentsSharedApplicationState } from '../../../types/order/documents/shared/interfaces';
import { ISharedDocumentAction } from './actions';

export const DocumentSharedReducer = (
  oldState: IDocumentsSharedApplicationState,
  action: ISharedDocumentAction
): IDocumentsSharedApplicationState => {
  if (action.type === 'SetSharedStandardDocuments') {
    return { ...oldState, standardDocuments: action.payload };
  } else {
    throw new Error('DocumentSharedReducer Error');
  }
};
